<template>
  <section class="form-list">
    <el-form
        ref="form"
        class="form form-extra-large"
        label-position="left"
        label-width="160px"
    >
      <el-form-item label="ID">{{ id }}</el-form-item>
      <el-form-item label="添加时间">{{ postData.add_time | timeToYmdHis }}</el-form-item>

      <el-form-item label="添加者">
        <v-avatar-nickname :value="postData.avatar" :nickname="postData.nickname"/>
      </el-form-item>
      <el-form-item label="错误类型">{{ postData.error_type }}</el-form-item>
      <el-form-item label="系统返回信息">{{ postData.error_message }}</el-form-item>
      <el-form-item label="有赞订单号">{{ postData.order_number }}</el-form-item>
      <el-form-item label="有赞券码">{{ postData.ticket_code }}</el-form-item>
      <el-form-item label="有赞二维码">{{ postData.qr_code }}</el-form-item>
      <el-form-item label="请求结果摘要">{{ postData.response_body }}</el-form-item>

      <el-form-item>
        <el-button @click="RouteConfig.errorLogYouZanList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { getYouZanDetails } from '@/api/error-log';

export default {
  name: RouteConfig.errorLogYouZanDetail.name,
  data: () => ({
    RouteConfig,
    postData: {},
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      const { isError, data } = await getYouZanDetails(this.id);
      if (isError || !data) return;
      this.postData = data;
    },
  },
};
</script>
